import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { micPermissionView } from '$comp/main/root.reducer'
import { MutedMicIcon } from '$common/icons/muted-mic'
import { MicIcon } from '$common/icons/mic'
import { enableNoSleep } from '$func/no-sleep'
import { vibrate } from '$func/vibrate'
import {
  showMicPermissionDeniedDialog,
  showMicPermissionPromptDialog,
} from '$comp/modals/permission-dialog'
import { RecorderStatus } from '../../send-field.type'
import { SendFieldIconButton } from '../icon-button'

export function RecordButton({
  state,
  setRecorderState,
}: {
  state: RecorderStatus
  setRecorderState: (state: RecorderStatus) => unknown
}) {
  const micPermission = useSelector(micPermissionView)
  const disabled = micPermission === 'denied'

  const requestRecord = useCallback(() => {
    if (micPermission === 'prompt') {
      showMicPermissionPromptDialog()
    } else if (micPermission === 'denied') {
      showMicPermissionDeniedDialog()
    } else if (!(state === 'PRESSED' || state === 'RECORD')) {
      if (disabled) return
      setRecorderState('PRESSED')
      enableNoSleep('recorder')
      vibrate()
    }
  }, [state, micPermission])

  return (
    <SendFieldIconButton onClick={requestRecord}>
      {disabled ? <MutedMicIcon /> : <MicIcon />}
    </SendFieldIconButton>
  )
}
